export * from './options';
export * from './simulations';

export function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
